import React from 'react';

import './AccountSection.css';
import InputField from '../InputField';
import HoveredDropDown from '../HoveredDropDown';
import { checkValidation, validations } from '../../../../constants/Validators';

export interface IAccountSectionProps {
  email: string,
  emailErrorMessage: string,
  mobileErrorMessage: string,
  mobileNumber: string,
  password: string,
  securityAnswer: string,
  securityQuestion:{
    id: string,
    text: string,
  },
  securityQuestionList:{
    id: string,
    text: string,
  }[],
  showError: boolean,
  title: string,
  userName: string,
  userNameErrorMessage: string,
  changeEmail:(email: string) => void,
  changeMobile:(mobile: string) => void,
  changeUserData:(key:string, value: string) => void,
  changeUserName:(name: string) => void
};

const AccountSection = (props: IAccountSectionProps) => {
  const onSelected = (field) => (item) => props.changeUserData(field, item);

  const changeValue = (field) => (value) => props.changeUserData(field, value);

  const changeUserName = (value) => {
   props.changeUserName(value);
  }

  const changeEmail = (value) => props.changeEmail(value);

  const changeMobile = (value) => props.changeMobile(value);

  const { title, showError, userName, email, password, mobileNumber,
    securityAnswer, securityQuestion, securityQuestionList, userNameErrorMessage,
    emailErrorMessage, mobileErrorMessage } = props;
  return (
    <div className="appendBottom40 accountSection">
      <p className="latoBlack font22 appendBottom20 blacktext">{title}</p>
      <div className="formDataContainer">
        <div className="makeFlex wrap">
          <InputField
            value={userName}
            label="Create username"
            maxLength={30}
            error={!!userNameErrorMessage || (showError && !checkValidation(userName, validations.userName))}
            type={'text'}
            placeholder="Type a username for your IRCTC account"
            errorMsg={userNameErrorMessage || 'Enter a valid username'}
            validations={validations.userName}
            changeValue={changeUserName}
          />
          <InputField
            value={email}
            label="Enter your email address"
            maxLength={70}
            error={!!emailErrorMessage || (showError && !checkValidation(email, validations.email))}
            type={'text'}
            placeholder="OTP will be sent to this email"
            errorMsg={emailErrorMessage || 'Enter a valid email address'}
            changeValue={changeEmail}
          />
          <InputField
            value={mobileNumber}
            label="Enter your mobile number"
            maxLength={10}
            error={!!mobileErrorMessage || (showError && !checkValidation(mobileNumber, validations.mobileNumber))}
            type={'number'}
            placeholder="OTP will be sent to this mobile number"
            errorMsg={mobileErrorMessage || 'Enter a valid mobile number'}
            prefixCode={'+91'}
            changeValue={changeMobile}
          />
          <InputField
            value={password}
            label="Create password"
            maxLength={15}
            error={showError && !checkValidation(password, validations.password)}
            type={'password'}
            errorMsg="Enter a valid password"
            placeholder="Type a password for your IRCTC account"
            eyeIcon={true}
            validations={validations.password}
            changeValue={changeValue('password')}
          />
          <HoveredDropDown
            classNames={'inputFieldContainer'}
            data={securityQuestionList}
            defaultSelected={securityQuestion}
            labelName="Select a security question"
            onSelected={onSelected('securityQuestion')}
          />
          <InputField
            value={securityAnswer}
            label="Enter a security answer"
            maxLength={20}
            error={showError && !checkValidation(securityAnswer, validations.securityAnswer)}
            type={'text'}
            placeholder="Type an answer for your security question"
            errorMsg={'Enter a valid security answer'}
            validations={validations.securityAnswer}
            changeValue={changeValue('securityAnswer')}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountSection;
